<template>
  <div
    class="absolute cursor-pointer pointer-events-auto transition-all duration-150 rounded"
    :class="selected ? 'border-2 border-blue-500 bg-blue-500/15' : 'border border-blue-400/40 bg-transparent hover:bg-blue-500/10'"
    :style="regionStyle"
    :title="line.text"
    data-testid="ocr-line-region"
    @click.stop="artifactsStore.toggleLineSelection(index)"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useArtifactsStore } from '../../store/useArtifactsStore';
import type { OcrLine } from '../../store/useArtifactsStore';

const props = defineProps<{
  line: OcrLine;
  index: number;
  selected: boolean;
}>();

const artifactsStore = useArtifactsStore();

const regionStyle = computed(() => {
  const box = props.line.boundingBox;
  return {
    top: `${box.top * 100}%`,
    left: `${box.left * 100}%`,
    width: `${box.width * 100}%`,
    height: `${box.height * 100}%`,
  };
});
</script>
